type StorageValue<T> = T | null;

export const storage = {
  // Sets a value in local-storage after serializing it to JSON
  set<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`localStorage set error for key "${key}"`, error);
    }
  },
	
  // Gets a value from local-storage and deserializes it from JSON
  get<T>(key: string): StorageValue<T> {
    try {
      const item = localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : null;
    } catch (error) {
      console.error(`localStorage get error for key "${key}"`, error);
      return null;
    }
  },
	
  // Removes a value from local-storage
  remove(key: string): void {
    localStorage.removeItem(key);
  },
};
